import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";

import { closeModal, openModal } from "../../modal/modal";
import { ModalNames } from "../../../../Constants/modalNames";
import { queryClient } from "../../../store";
import { checkLoginActions } from "../../auth/checkLogin";

export type SeenAnnouncedNotificationLoadAction = {
  type: string;
  payload: {
    id?: number;
  };
};

export type SeenAnnouncedNotificationData = {};

const SeenAnnouncedNotification = new ReduxFetchState<
  SeenAnnouncedNotificationData,
  { id?: number },
  any
>("seenAnnouncedNotification");

export function* watchSeenAnnouncedNotification(action: SeenAnnouncedNotificationLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const { id } = action.payload;
    const data: SeenAnnouncedNotificationData = yield axios({
      url: `/api/v1/users/notification/${id}/seen`,
      method: "GET",
      headers: { lang },
    });

    yield put(SeenAnnouncedNotification.actions.loadSuccess());
    queryClient.removeQueries({ queryKey: ["getAnnouncedNotifications", lang] });
    yield put(closeModal());
    yield put(checkLoginActions.load());
  } catch (e: any) {
    const backendError = e?.response?.data?.error || e?.message || "Something went wrong";
    alert({ message: backendError, type: "error" });
    yield put(SeenAnnouncedNotification.actions.loadFailure(e.message));
  }
}

export function* seenAnnouncedNotificationSagas() {
  yield takeEvery(SeenAnnouncedNotification.actionTypes.load, watchSeenAnnouncedNotification);
}

export function useSeenAnnouncedNotification() {
  const { loading, data, ...seenAnnouncedNotificationState } = useAppSelector(
    (state) => state.seenAnnouncedNotification,
  );
  const dispatch = useAppDispatch();

  const dispatchSeenAnnouncedNotification = useCallback(
    (data: { id?: number }) => {
      dispatch(SeenAnnouncedNotification.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...seenAnnouncedNotificationState,
    dispatchSeenAnnouncedNotification,
    seenAnnouncedNotificationLoading: loading,
    seenAnnouncedNotificationData: data,
  };
}

export const {
  actionTypes: seenAnnouncedNotificationActionsTypes,
  actions: seenAnnouncedNotificationActions,
  reducer: seenAnnouncedNotificationReducer,
} = SeenAnnouncedNotification;
